module.exports = __webpack_public_path__ + "img/Darius_Headshot-photoaidcom-cropped.18633149.JPG";